/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

import {
    DoneTitle,
    IconAcceptedCard,
    IconApprovalDeniedCard,
    IconCanceledByEmployeeCard,
    IconCanceledByVisitorCard,
    IconChangesRequestedCard,
    ArrowRightIcon,
    IconInformationApprovedCard,
    IconInformationRejectedCard,
    IconPendingToReviewForApprovalCard,
    IconPendingToReviewInformationCard,
    IconPendingToUploadInformationCard,
    IconRejectedByVisitorCard,
    IconUnattendedCard,
    WaitingTitle, IconApprovedCard
} from "../../../../../components/buttons/IconButtons";
import ButtonSubAction from "../../../../../components/buttons/ButtonSubAction";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {getAccessMethodById} from "../../../../../enums/accessMethodEnum";
import {getDeviceAccessTypeById} from "../../../Devices/Model/Model";
import routes from "../../../../../Routes/routes";

export const VISITOR_INVITATION_MODEL = {
    hostId : null,
    id: null,
    visitors:[],
    visitorId:null,
    startDate: null,
    endDate: null,
    zoneId: '',
    visitorNumber: '',
    visitorType: null,
    requestAccessId: null,
    documentationValidated: false,
    accessToleranceMin: null,

    toRegister: function () {
        return {
            id: this.id,
            hostId: this.hostId,
            visitors: this.visitors,
            startDate: (this.startDate instanceof Date)
                ? this.startDate.getTime()
                : new Date(this.startDate).getTime(),
            endDate: (this.endDate instanceof Date)
                ? this.endDate.getTime()
                : new Date(this.endDate).getTime(),
            zoneId: this.zoneId,
            visitorNumber: this.visitorNumber,
            visitorType: this.visitorType,
            requestAccessId: this.requestAccessId,
            documentationValidated: this.documentationValidated,
            accessToleranceMin: (this.accessToleranceMin === '' || this.accessToleranceMin == null)
                ? null
                : Number(this.accessToleranceMin)
        };
    },

    set: function (data) {
        return {
            ...this,
            id: data.id,
            hostId: data.hostId || null,
            visitorId: data.visitorId || null,
            startDate: data.startDate || null,
            endDate: data.endDate || null,
            zoneId: data.zoneId || null,
            visitorNumber: data.visitorNumber || '',
            visitorType: data.visitorType || '',
            documentationValidated: data.documentationValidated || false,
            accessToleranceMin: data.accessToleranceMin ?? null,
        };
    },
    setFromRequestAccess: function (data) {
        return {
            ...this,
            hostId: data.visitToId || null,
            visitors: [data.requestedById],
            startDate: null,
            endDate: null,
            zoneId: null,
            visitorNumber: '',
            visitorType: '',
            requestAccessId: data.requestAccessId,
            documentationValidated: data.documentationValidated,
            accessToleranceMin: null
        };
    },
    clearFromRequestAccess: function () {
        return {
            ...this,
            startDate: null,
            endDate: null,
            zoneId: null,
            visitorNumber: '',
            visitorType: '',
            documentationValidated: false,
            accessToleranceMin: null
        };
    },
    buildDataToHost: function (data) {
        return {
            ...this,
            id: data.visitToId,
            name: data.visitToName,
            lastName: data.visitToLastName,
            secondLastName: data.visitToSecondLastName,
            email: data?.visitToEmail || '',
            phone: data?.visitToPhoneNumber || '',
        };
    },
    buildDataToVisitor: function (data) {
        return {
            ...this,
            id: data.requestedById,
            name: data.requestedByName,
            lastName: data.requestedByLastName,
            secondLastName: data.requestedBySecondLastName,
            email: data?.requestedByEmail || '',
            phone: data?.requestedByPhoneNumber || '',
        };
    },
    isValid: function () {
        return (
            this.startDate != null &&
            this.endDate != null &&
            this.zoneId !== '' && this.zoneId !== null &&
            this.visitorType !== '' && this.visitorType !== null &&
            this.accessToleranceMin !== '' && this.accessToleranceMin != null
        );
    },
    isValidTolerance: function (){
        return this.accessToleranceMin === '' || this.accessToleranceMin === null || this.accessToleranceMin === undefined;
    },
    isValidFields: function (fields) {
        return fields?.length > 0;
    },
};

export const VISITOR_SUB_VIEW_MODEL = {
    INVITATION: {
        ONGOING: "ONGOING",
        INCOMING: "INCOMING"
    },
    REQUESTS: {
        REQUESTED_INVITATIONS: 'REQUESTED_INVITATIONS',
        INVITATION_STATUS: 'INVITATION_STATUS',
    },
    VISITORS: {
        VISITORS:"VISITORS",
        ACTIVE_REQUESTS:"ACTIVE_REQUESTS"
    }
}

export const issetItem = (list, key, value) => {
   return list.find(item => item.hasOwnProperty(key) && item[key] === value)
}

export const INVITATION_STATUS_CARD_MODEL = {
    PENDING: {
        id:"PENDING",
        titleTrans: "pending",
        classCard: "card-shades-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2",
        fontColor: "font-color-shades-700",
        infoColor: "icon-color-shades-700",
        list: [
            {
                statusId: STATUS_MODEL.PENDING_REVIEW, //statusId
                total:0,
                titleTrans: "pending_to_review_information",
                descriptionTrans: "admin_has_not_taken_any_action_yet",
                cols: "col-4",
                classCard: "card-shades-100",
                Icon:IconPendingToReviewInformationCard
            },
            {
                statusId: STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION, // statusId
                total:0,
                titleTrans: "PENDING_TO_UPLOAD_INFORMATION",
                descriptionTrans: "visitor_has_not_uploaded_required_documents_yet",
                cols: "col-4",
                classCard: "card-shades-100",
                Icon:IconPendingToUploadInformationCard
            },
            {
                approvalStatusId: STATUS_MODEL.PENDING_REVIEW, // approvalStatusId
                total:0,
                titleTrans: "invitation_pending_to_review_for_approval",
                descriptionTrans: "visitor_invitation_is_still_pending_approval",
                cols: "col-4",
                classCard: "card-shades-100",
                Icon:IconPendingToReviewForApprovalCard
            }
        ]
    },
    IN_PROGRESS: {
        id:"IN_PROGRESS",
        titleTrans: "IN_PROGRESS",
        classCard: "card-warning-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-2 px-md-2 pl-xl-2 pr-xl-2",
        fontColor: "font-color-warning-700",
        infoColor: "icon-color-warning-700",
        list: [
            {
                visitorStatusId: STATUS_MODEL.UNATTENDED, // visitorStatusId
                total:0,
                titleTrans: "UNATTENDED",
                descriptionTrans: "visitor_has_not_taken_any_action_yet",
                cols: "col-6",
                classCard: "card-warning-100",
                Icon:IconUnattendedCard
            },
            {
                statusId: STATUS_MODEL.CHANGES_REQUESTED, // statusId
                total:0,
                titleTrans: "CHANGES_REQUESTED",
                descriptionTrans: "admin_requested_changes_in_approval_process",
                cols: "col-6",
                classCard: "card-warning-100",
                Icon:IconChangesRequestedCard
            },

        ]
    },
    COMPLETED: {
        id:"COMPLETED",
        titleTrans: "completed",
        classCard: "card-success-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-2 pr-xl-2",
        fontColor: "font-color-success-700",
        infoColor: "icon-color-success-700",
        list: [
            {
                visitorStatusId: STATUS_MODEL.ACCEPTED, // visitorStatusId
                total:0,
                titleTrans: "accepted_by_visitor",
                descriptionTrans: "visitor_accepted_the_invitation",
                cols: "col-4",
                classCard: "card-success-100",
                Icon:IconAcceptedCard
            },
            {
                approvalStatusId: STATUS_MODEL.APPROVED, //approvalStatusId
                total:0,
                titleTrans: "APPROVED",
                descriptionTrans: "admin_approved_the_invitation",
                cols: "col-4",
                classCard: "card-success-100",
                Icon:IconApprovedCard
            },
            {
                statusId: STATUS_MODEL.APPROVED, // statusId
                total:0,
                titleTrans: "validated_information",
                descriptionTrans: "visitor_information_has_been_validated",
                cols: "col-4",
                classCard: "card-success-100",
                Icon:IconInformationApprovedCard
            }
        ]
    },
    NOT_APPROVED: {
        id:"NOT_APPROVED",
        titleTrans: "not_approved",
        classCard: "card-error-code-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-2 pr-md-2 pl-xl-2 pr-xl-0",
        fontColor: "font-color-error-600",
        infoColor: "icon-color-error-code-700",
        list: [
            {
                visitorStatusId: STATUS_MODEL.REJECTED, //visitorStatusId
                total:0,
                titleTrans: "rejected_by_visitor",
                descriptionTrans: "visitor_rejected_the_invitation",
                cols: "col",
                classCard: "card-error-code-100",
                Icon:IconRejectedByVisitorCard
            },
            {
                visitorStatusId: STATUS_MODEL.CANCELED, //visitorStatusId
                total:0,
                titleTrans: "canceled_by_visitor",
                descriptionTrans: "visitor_canceled_the_invitation",
                cols: "col",
                classCard: "card-error-code-100",
                Icon:IconCanceledByVisitorCard
            },
            {
                approvalStatusId: STATUS_MODEL.DENIED, //approvalStatusId
                total:0,
                titleTrans: "approval_denied",
                descriptionTrans: "admin_denied_approval_invitation",
                cols: "col",
                classCard: "card-error-code-100",
                Icon:IconApprovalDeniedCard
            },
            {
                statusId: STATUS_MODEL.REJECTED, //statusId
                total:0,
                titleTrans: "rejected_information",
                descriptionTrans: "admin_rejected_the_visitor_information",
                cols: "col",
                classCard: "card-error-code-100",
                Icon:IconInformationRejectedCard
            },
            {
                statusId: STATUS_MODEL.CANCELED, //statusId
                total:0,
                titleTrans: "canceled_by_admin",
                descriptionTrans: "admin_canceled_the_invitation",
                cols: "col",
                classCard: "card-error-code-100",
                classIcon:"text-sm-center text-md-center text-lg-center text-xl-center text-xxl-center",
                Icon:IconCanceledByEmployeeCard
            }
        ]
    },
}

export const ACTIVITY_LIST_MODEL = {
    INVITATION_CREATED: {
        Icon: DoneTitle,
        trans: "invitation_created",
        button: null,
    },
    APPROVAL_STATUS: {
        Icon: WaitingTitle,
        trans: "invitation_pending_to_review_for_approval",
        buttonDisabled: false,
        url: null,
        id: null,
        button:  (disabled, showIdentityValidationButton, onClick) =>  <ButtonSubAction
            id='btn_idm_view_approval_tracker'
            name='view_approval_tracker'
            onClick={onClick}
            Icon={ArrowRightIcon}
            disabled={disabled}
        />,
        [STATUS_MODEL.PENDING_REVIEW]: {
            Icon: WaitingTitle,
            trans: "invitation_pending_to_review_for_approval"
        },
        [STATUS_MODEL.CHANGES_REQUESTED]: {
            Icon: WaitingTitle,
            trans: "admin_requested_changes_in_approval_process",
        },
        [STATUS_MODEL.DENIED]: {
            Icon: DoneTitle,
            trans: "admin_denied_approval_invitation"
        },
        [STATUS_MODEL.APPROVED]: {
            Icon: DoneTitle,
            trans: "admin_approved_the_invitation",
        }
    },
    VISITOR_STATUS: {
        Icon: WaitingTitle,
        trans: "visitor_has_not_taken_any_action_yet",
        button: null,
        url:null,
        id: null,
        [STATUS_MODEL.UNATTENDED]: {
            Icon: WaitingTitle,
            trans: "visitor_has_not_taken_any_action_yet"
        },
        [STATUS_MODEL.REJECTED]: {
            Icon: DoneTitle,
            trans: "visitor_rejected_the_invitation"
        },
        [STATUS_MODEL.CANCELED]: {
            Icon: DoneTitle,
            trans: "visitor_canceled_the_invitation",
        },
        [STATUS_MODEL.ACCEPTED]: {
            Icon: DoneTitle,
            trans: "visitor_accepted_the_invitation",
        }
    },
    STATUS:{
        Icon: WaitingTitle,
        trans: "visitor_has_not_uploaded_required_documents_yet",
        buttonDisabled: true,
        url: routes.visitorRequest.documentation,
        id: null,
        button:  (disabled, showIdentityValidationButton, onClick) =>  <ButtonSubAction
            id='btn_idm_view_visitor_documentation'
            name='view_visitor_documentation'
            onClick={onClick}
            Icon={ArrowRightIcon}
            disabled={disabled}
        />,
        [STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION]: {
            Icon: WaitingTitle,
            trans: "visitor_has_not_uploaded_required_documents_yet",
        },
        [STATUS_MODEL.CANCELED]: {
            Icon: DoneTitle,
            trans: "admin_canceled_the_invitation",
        },
        [STATUS_MODEL.PENDING_REVIEW]: {
            Icon: WaitingTitle,
            trans: "pending_to_review_information",
        },
        [STATUS_MODEL.APPROVED]: {
            Icon: DoneTitle,
            trans: "visitor_information_has_been_validated",
        },
        [STATUS_MODEL.REJECTED]: {
            Icon: DoneTitle,
            trans: "admin_rejected_the_visitor_information",
        },
        [STATUS_MODEL.CHANGES_REQUESTED]: {
            Icon: WaitingTitle,
            trans: "admin_requested_changes_in_visitor_information",
        }
    },
    IDENTITY_VALIDATION:{
        Icon: WaitingTitle,
        trans: "waiting_for_identity_verification",
        buttonDisabled: true,
        url: routes.visitorRequest.identity,
        id: null,
        buttonHide: false,
        button:  (disabled, showIdentityValidationButton, onClick) =>  showIdentityValidationButton ?  <ButtonSubAction
            id='btn_idm_view_visitor_identity_validation'
            name='view_visitor_identity_validation'
            onClick={onClick}
            Icon={ArrowRightIcon}
            disabled={disabled}
        /> : "",
        [STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION]: {
            Icon: WaitingTitle,
            trans: "waiting_for_identity_verification",
        },
        [STATUS_MODEL.PENDING_REVIEW]: {
            Icon: WaitingTitle,
            trans: "waiting_for_identity_verification",
        },
        [STATUS_MODEL.VALIDATED]: {
            Icon: DoneTitle,
            trans: "identity_has_been_verified",
        },
        [STATUS_MODEL.DENIED]: {
            Icon: DoneTitle,
            trans: "identity_documents_rejected",
        }
    }
};

export const ACCESS_POINT_MODEL = {
    zoneName: "",
    deviceName: "",
    createdAt: null,
    accessMethod: null,
    deviceType: null,
    set: function (data) {
        return {
            ...this,
            zoneName: data?.device?.zone?.name,
            deviceName: data?.device?.name,
            createdAt: data.createdAt,
            accessMethod: getAccessMethodById(data?.accessMethod?.id) || null,
            deviceType: getDeviceAccessTypeById(data?.device?.deviceAccessType?.id) || null,
        };
    },
};


export const IDENTIFIERS_MODEL = {
    STATUS_ID: "statusId",
    APPROVAL_STATUS_ID: "approvalStatusId",
    VISITOR_STATUS_ID: "visitorStatusId"
}


export const INVITATION_VIEW_TYPE = {
    ONGOING: 0,
    INCOMING: 1,
    HISTORY: 2, //Used in Visitor -> Update -> Invitation history
    REQUESTED_INVITATIONS: 3, // Used in Requests -> Requested invitations
    INVITATION_STATUS:4 // Used in requests -> Invitation status
}

// Determines whether the given date is still valid (not expired).
// Returns true if the provided date is equal to or later than the current time.
export const invitationInTime = (date) => {
    return new Date(date).getTime() >= new Date().getTime();
}
